/* global window, document, Tabulator */

(function (window, document) {
    var root = document.getElementById('radar-cpv-root');
    if (!root) return;

    var apiBase = (root.getAttribute('data-api-base') || '').replace(/\/+$/, '');
    var client = new window.AppaltiMap.ApiGatewayClient({
        baseUrl: apiBase,
        tokenStore: new window.AppaltiMap.TokenStore('appaltimap_auth')
    });

    var VG_RADAR_CPV_MODE_STORAGE_KEY = 'vg-radar-cpv-mode';
    var _vgRadarCpvGatewaySessionOk = false;
    var _vgCompanyBundle = null; // { profileId, territories: [], cpv: [] }
    var _vgRadarCpvLastMode = null;

    function qs(sel, el) { return (el || document).querySelector(sel); }
    function setStatus(msg) { var el = qs('[data-radar-status]', root); if (el) el.textContent = msg || ''; }

    function escHtml(s) {
        if (s == null) return '';
        return String(s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function parseEuroNumber(v) {
        if (v == null || v === '') return NaN;
        if (typeof v === 'number' && isFinite(v)) return v;
        var s = String(v).trim().replace(/\s/g, '');
        if (!s) return NaN;
        if (s.indexOf(',') !== -1 && s.indexOf('.') !== -1) return parseFloat(s.replace(/\./g, '').replace(',', '.'), 10);
        if (s.indexOf(',') !== -1) return parseFloat(s.replace(',', '.'), 10);
        return parseFloat(s, 10);
    }

    function formatEuroIt(v) {
        var n = parseEuroNumber(v);
        if (!isFinite(n)) return '—';
        return n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function formatIntIt(v) {
        var n = Number(v);
        if (!isFinite(n)) return '—';
        return Math.round(n).toLocaleString('it-IT', { maximumFractionDigits: 0 });
    }

    function stripTrailingZerosToPrefix(code) {
        var s = String(code || '').replace(/\D/g, '');
        if (!s) return '';
        if (s.length > 8) s = s.slice(0, 8);
        s = s.replace(/0+$/g, '');
        return s || String(code || '').replace(/\D/g, '').slice(0, 8);
    }

    function persistRadarCpvMode(mode) {
        try {
            if (mode === 'company' || mode === 'explore') {
                localStorage.setItem(VG_RADAR_CPV_MODE_STORAGE_KEY, mode);
            }
        } catch (e) {}
    }

    function loadRadarCpvMode() {
        try {
            var m = localStorage.getItem(VG_RADAR_CPV_MODE_STORAGE_KEY);
            return m === 'company' ? 'company' : 'explore';
        } catch (e) {
            return 'explore';
        }
    }

    function fetchGhostSessionToken() {
        return fetch('/members/api/session/', { method: 'GET', credentials: 'include' })
            .then(function (r) {
                if (r.status === 204) return null;
                if (!r.ok) {
                    return r.text().then(function (t) {
                        throw new Error('Ghost session HTTP ' + r.status + (t ? ' ' + t.slice(0, 120) : ''));
                    });
                }
                return r.text();
            })
            .then(function (token) {
                token = (token || '').trim();
                return token || null;
            });
    }

    function gatewaySessionLogin(sessionToken) {
        if (!apiBase) return Promise.reject(new Error('API base mancante'));
        return fetch(apiBase + '/auth/ghost/session/login', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ session_token: sessionToken })
        }).then(function (r) {
            return r.json().then(function (data) {
                if (!r.ok) {
                    var d = (data && data.detail) ? String(data.detail) : '';
                    throw new Error(d || ('Gateway login HTTP ' + r.status));
                }
                return data;
            });
        });
    }

    function ensureGatewaySession() {
        if (_vgRadarCpvGatewaySessionOk) return Promise.resolve();
        return fetchGhostSessionToken()
            .then(function (token) {
                if (!token) throw new Error('Accedi per caricare il profilo aziendale');
                return gatewaySessionLogin(token);
            })
            .then(function () {
                _vgRadarCpvGatewaySessionOk = true;
            });
    }

    function companyCpvPrefixesFromBundle(cpvItems) {
        var out = [];
        (cpvItems || []).forEach(function (it) {
            var raw = it && (it.cpv_code || it.code || it.cpv || it.value);
            var p = stripTrailingZerosToPrefix(raw || '');
            if (p && out.indexOf(p) === -1) out.push(p);
        });
        return out;
    }

    function fetchCompanyBundleForRadarCpv() {
        if (_vgCompanyBundle) return Promise.resolve(_vgCompanyBundle);
        return ensureGatewaySession()
            .then(function () {
                return fetch(apiBase + '/company-profiles?limit=1&offset=0', {
                    credentials: 'include',
                    headers: { Accept: 'application/json' }
                });
            })
            .then(function (r) {
                return r.json().then(function (j) {
                    if (!r.ok) throw new Error((j && j.detail && String(j.detail)) || ('HTTP ' + r.status));
                    return j;
                });
            })
            .then(function (list) {
                var items = (list && list.items) ? list.items : [];
                if (!items.length) return { profileId: null, territories: [], cpv: [] };
                var pid = items[0].id;
                return fetch(apiBase + '/company-profiles/' + encodeURIComponent(pid) + '/bundle', {
                    credentials: 'include',
                    headers: { Accept: 'application/json' }
                })
                    .then(function (r2) {
                        return r2.json().then(function (j2) {
                            if (!r2.ok) throw new Error((j2 && j2.detail && String(j2.detail)) || ('HTTP ' + r2.status));
                            return j2;
                        });
                    })
                    .then(function (bundle) {
                        return {
                            profileId: pid,
                            territories: (bundle && bundle.territories) ? bundle.territories : [],
                            cpv: (bundle && bundle.cpv) ? bundle.cpv : []
                        };
                    });
            })
            .then(function (b) {
                _vgCompanyBundle = b;
                return b;
            })
            .catch(function () {
                _vgCompanyBundle = { profileId: null, territories: [], cpv: [] };
                return _vgCompanyBundle;
            });
    }

    function pad2(n) { return (n < 10 ? '0' : '') + n; }
    function toISODate(d) { return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()); }
    function initDefaultYearDates() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var from = form.querySelector('input[name="date_from"]');
        var to = form.querySelector('input[name="date_to"]');
        if (!from || !to) return;
        if (String(from.value || '').trim() || String(to.value || '').trim()) return;
        var now = new Date();
        var jan1 = new Date(now.getFullYear(), 0, 1);
        from.value = toISODate(jan1);
        to.value = toISODate(now);
    }

    function readFilters() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return {};
        var fd = new FormData(form);
        var out = {};
        var companyCb = form.querySelector('#radar-cpv-company-mode');
        var inCompany = !!(companyCb && companyCb.checked);

        ['metric', 'min_participations', 'date_from', 'date_to'].forEach(function (k) {
            var v = fd.get(k);
            if (v != null && String(v).trim() !== '') out[k] = String(v).trim();
        });

        var mem = (root.getAttribute('data-member-uuid') || '').trim();

        if (inCompany) {
            var b = _vgCompanyBundle;
            var prefs = companyCpvPrefixesFromBundle(b && b.cpv);
            if (prefs && prefs.length) {
                out.cpv_prefixes = prefs.join(',');
            }

            var terrCb = document.getElementById('radar-cpv-in-saved-area');
            if (terrCb && terrCb.checked) {
                out.company_mode = '1';
                if (mem) out.member = mem;
            }
            return out;
        }

        var cpv = fd.get('cpv_code');
        if (cpv != null && String(cpv).trim() !== '') out.cpv_code = String(cpv).trim();

        var areaCb = document.getElementById('radar-cpv-in-saved-area');
        if (areaCb && areaCb.checked && !areaCb.disabled) {
            out.in_saved_area = '1';
            if (mem) out.member = mem;
        }
        return out;
    }

    function uncheckSavedAreaIfAuthOrAreaError(status) {
        if (status !== 400 && status !== 401) return;
        var cb = document.getElementById('radar-cpv-in-saved-area');
        if (cb && cb.checked) cb.checked = false;
    }

    function initSavedAreaFromMap() {
        var uuid = (root.getAttribute('data-member-uuid') || '').trim();
        var cb = document.getElementById('radar-cpv-in-saved-area');
        var hint = document.getElementById('radar-cpv-area-hint');
        if (!cb) return Promise.resolve();
        var form = qs('[data-radar-filters]', root);
        var companyCb = form ? form.querySelector('#radar-cpv-company-mode') : null;
        if (companyCb && companyCb.checked) {
            return Promise.resolve();
        }
        if (!uuid) {
            cb.disabled = true;
            if (hint) {
                hint.hidden = false;
                hint.textContent = 'UUID membro non disponibile: impossibile verificare l’area sulla mappa.';
            }
            return Promise.resolve();
        }
        return fetch(apiBase + '/telegram/settings?member=' + encodeURIComponent(uuid), {
            headers: { Accept: 'application/json' }
        })
            .then(function (r) {
                return r.ok ? r.json() : {};
            })
            .then(function (data) {
                var hasArea = data && data.mode === 'area' && data.area && data.area.geojson;
                if (hasArea) {
                    cb.disabled = false;
                    if (hint) {
                        hint.hidden = true;
                        hint.textContent = '';
                    }
                } else {
                    cb.disabled = true;
                    cb.checked = false;
                    if (hint) {
                        hint.hidden = false;
                        hint.textContent =
                            'Salva un’area sulla mappa principale (strumento disegno) per abilitare questo filtro.';
                    }
                }
            })
            .catch(function () {
                cb.disabled = true;
                if (hint) {
                    hint.hidden = false;
                    hint.textContent = 'Impossibile verificare se hai un’area salvata sulla mappa.';
                }
            });
    }

    function initCpvAutocomplete() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var input = form.querySelector('input[name="cpv_query"]');
        var hidden = form.querySelector('input[name="cpv_code"]');
        var clearBtn = form.querySelector('[data-cpv-clear]');
        var list = document.getElementById('radar-cpv-cpv-list');
        if (!input || !hidden || !list) return;
        var memberUuid = (root.getAttribute('data-member-uuid') || '').trim();

        var lastFetch = 0;
        var pending;
        var saveTimer;

        function persistCpv(prefix) {
            if (!memberUuid) return;
            if (saveTimer) window.clearTimeout(saveTimer);
            saveTimer = window.setTimeout(function () {
                fetch(apiBase + '/telegram/cpv', {
                    method: 'POST',
                    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
                    body: JSON.stringify({ member_uuid: memberUuid, cpv_prefix: prefix || null })
                }).catch(function () {});
            }, 220);
        }

        function syncClearBtn() {
            if (!clearBtn) return;
            clearBtn.disabled = !String(hidden.value || '').trim();
        }

        var lastResolvedPrefix = '';
        function resolveAndShowLabel(prefix) {
            var p = String(prefix || '').trim();
            if (!p || p === lastResolvedPrefix) return Promise.resolve();
            lastResolvedPrefix = p;
            var url = apiBase + '/radar/hub/cpv-suggest?q=' + encodeURIComponent(p) + '&limit=1';
            return fetch(url, { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : {}; })
                .then(function (data) {
                    var it = data && data.items && data.items[0];
                    if (!it) return;
                    var code = String(it.code_main || '').trim();
                    var label = String(it.label_it || '').trim();
                    if (!code) return;
                    input.value = code + (label ? ' — ' + label : '');
                })
                .catch(function () {});
        }

        function render(items) {
            while (list.firstChild) list.removeChild(list.firstChild);
            (items || []).forEach(function (it) {
                var opt = document.createElement('option');
                var code = it.code_main || '';
                var label = it.label_it || '';
                opt.value = code + (label ? ' — ' + label : '');
                list.appendChild(opt);
            });
        }

        function fetchSuggest(q) {
            var now = Date.now();
            lastFetch = now;
            var url = apiBase + '/radar/hub/cpv-suggest?q=' + encodeURIComponent(q) + '&limit=15';
            return fetch(url, { headers: { Accept: 'application/json' } })
                .then(function (r) { if (!r.ok) throw r; return r.json(); })
                .then(function (data) {
                    if (lastFetch !== now) return;
                    render((data && data.items) || []);
                })
                .catch(function () {});
        }

        input.addEventListener('input', function () {
            var q = String(input.value || '').trim();
            if (pending) window.clearTimeout(pending);
            if (q.length < 2 && !/\d/.test(q)) return;
            pending = window.setTimeout(function () { fetchSuggest(q); }, 180);
        });

        input.addEventListener('input', function () {
            var raw = String(input.value || '').trim();
            var digits = raw.replace(/\D/g, '');
            hidden.value = digits ? stripTrailingZerosToPrefix(digits) : '';
            persistCpv(hidden.value);
            syncClearBtn();
        });

        input.addEventListener('blur', function () {
            var raw = String(input.value || '').trim();
            if (!raw) {
                hidden.value = '';
                persistCpv('');
                lastResolvedPrefix = '';
                syncClearBtn();
                return;
            }
            var digits = raw.replace(/\D/g, '');
            if (!digits) return;
            hidden.value = stripTrailingZerosToPrefix(digits);
            persistCpv(hidden.value);
            syncClearBtn();
            resolveAndShowLabel(hidden.value);
        });

        if (clearBtn) {
            clearBtn.addEventListener('click', function () {
                input.value = '';
                hidden.value = '';
                lastResolvedPrefix = '';
                persistCpv('');
                syncClearBtn();
            });
        }

        syncClearBtn();

        if (memberUuid) {
            fetch(apiBase + '/telegram/settings?member=' + encodeURIComponent(memberUuid), { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : {}; })
                .then(function (data) {
                    var p = String((data && data.cpv_prefix) || '').trim();
                    if (!p) return;
                    var companyCb = form.querySelector('#radar-cpv-company-mode');
                    if (companyCb && companyCb.checked) return;
                    hidden.value = p;
                    syncClearBtn();
                    resolveAndShowLabel(p);
                })
                .catch(function () {});
        }
    }

    var table;

    /** Path CPV per le classifiche (Tabulator con ajaxRequestFunc non applica ajaxURLGenerator da solo). */
    function cpvRankingsPathUrl() {
        var f = readFilters();
        var form = qs('[data-radar-filters]', root);
        var companyOn = !!(form && form.querySelector('#radar-cpv-company-mode') && form.querySelector('#radar-cpv-company-mode').checked);
        if (companyOn) {
            return apiBase + '/radar/cpv/0/rankings';
        }
        var cpv = String(f.cpv_code || '').replace(/\D/g, '').slice(0, 8);
        cpv = stripTrailingZerosToPrefix(cpv) || '0';
        return apiBase + '/radar/cpv/' + encodeURIComponent(cpv) + '/rankings';
    }

    function buildTable() {
        if (typeof Tabulator === 'undefined') { setStatus('Tabulator non disponibile.'); return; }
        var el = qs('#radar-cpv-table', root);
        if (!el || table) return;

        table = new Tabulator(el, {
            layout: 'fitColumns',
            placeholder: 'Nessun dato',
            pagination: true,
            paginationMode: 'remote',
            paginationSize: 25,
            paginationSizeSelector: [25, 50, 100],
            ajaxURL: apiBase + '/radar/cpv/00000000/rankings',
            ajaxParams: function () { return readFilters(); },
            ajaxRequestFunc: function (url, cfg, params) {
                var token = client.tokenStore.getToken() || '';
                var headers = { Accept: 'application/json' };
                if (token) headers.Authorization = 'Bearer ' + token;
                url = cpvRankingsPathUrl();
                var sep = url.indexOf('?') >= 0 ? '&' : '?';
                var qsStr = new URLSearchParams(params || {}).toString();
                var fullUrl = qsStr ? url + sep + qsStr : url;
                return fetch(fullUrl, { method: 'GET', headers: headers }).then(function (r) {
                    if (!r.ok) {
                        return r.text().then(function (t) {
                            var msg = r.statusText || 'Errore';
                            try {
                                var body = JSON.parse(t);
                                var d = body && body.detail;
                                msg =
                                    typeof d === 'string'
                                        ? d
                                        : d
                                          ? JSON.stringify(d)
                                          : msg;
                            } catch (ignore) {}
                            setStatus(msg);
                            uncheckSavedAreaIfAuthOrAreaError(r.status);
                            throw new Error(msg);
                        });
                    }
                    return r.json();
                });
            },
            ajaxURLGenerator: function () {
                return cpvRankingsPathUrl();
            },
            ajaxResponse: function (url, params, resp) {
                var perPage = resp.per_page || params.size || 25;
                var total = resp.total || 0;
                var lastPage = Math.max(1, Math.ceil(total / perPage) || 1);
                return { last_page: lastPage, data: resp.items || [] };
            },
            columns: [
                {
                    title: 'Azienda',
                    field: 'canonical_name',
                    minWidth: 180,
                    formatter: function (cell) {
                        var row = cell.getRow().getData();
                        var name = cell.getValue() || row.normalized_name || '—';
                        return '<span>' + escHtml(name) + '</span>';
                    }
                },
                { title: 'Part.', field: 'participations_total', width: 90, hozAlign: 'right', formatter: function (c) { return formatIntIt(c.getValue()); } },
                { title: 'Vitt.', field: 'wins_total', width: 80, hozAlign: 'right', formatter: function (c) { return formatIntIt(c.getValue()); } },
                {
                    title: 'Win rate %',
                    field: 'win_rate',
                    width: 110,
                    hozAlign: 'right',
                    formatter: function (cell) {
                        var v = parseEuroNumber(cell.getValue());
                        if (!isFinite(v)) return '—';
                        var pct = v <= 1 ? v * 100 : v;
                        return pct.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' %';
                    }
                },
                { title: 'Imp. agg. €', field: 'awarded_amount_eur_sum', width: 130, hozAlign: 'right', formatter: function (c) { return formatEuroIt(c.getValue()); } }
            ]
        });
        root._vgTabulator = table;
    }

    function refresh() {
        if (!table) return;
        setStatus('Caricamento…');
        table.setData()
            .then(function () { setStatus(''); })
            .catch(function () {
                setStatus('Impossibile caricare.');
            });
    }

    function applyCompanyModeUiCpv(mode) {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var chkCompany = form.querySelector('#radar-cpv-company-mode');
        var chkTerr = document.getElementById('radar-cpv-in-saved-area');
        var wrapTerr = document.getElementById('radar-cpv-saved-area-wrap');
        var terrLabelSpan = wrapTerr ? wrapTerr.querySelector('span') : null;
        var cpvInput = form.querySelector('input[name="cpv_query"]');
        var cpvHidden = form.querySelector('input[name="cpv_code"]');
        var clearBtn = form.querySelector('[data-cpv-clear]');
        var hintCompany = document.getElementById('radar-cpv-company-hint');

        var TERR_LABEL_EXPLORE = "Solo bandi nell’area salvata sulla mappa principale";
        var TERR_LABEL_COMPANY = "Solo territori salvati nel company profile";

        function setCompanyHint(msg, visible) {
            if (!hintCompany) return;
            hintCompany.hidden = !visible;
            hintCompany.textContent = visible ? (msg || '') : '';
        }

        function resetCpvToEmpty() {
            if (cpvHidden) cpvHidden.value = '';
            if (cpvInput) cpvInput.value = '';
            if (clearBtn) clearBtn.disabled = true;
        }

        if (mode !== 'company') {
            if (_vgRadarCpvLastMode === 'company') {
                resetCpvToEmpty();
            }
            if (chkCompany) chkCompany.checked = false;
            if (cpvInput) cpvInput.disabled = false;
            if (clearBtn) clearBtn.disabled = !String((cpvHidden && cpvHidden.value) || '').trim();
            if (terrLabelSpan) terrLabelSpan.textContent = TERR_LABEL_EXPLORE;
            setCompanyHint('', false);
            _vgRadarCpvLastMode = 'explore';
            initSavedAreaFromMap();
            return;
        }

        if (chkCompany) chkCompany.checked = true;
        if (terrLabelSpan) terrLabelSpan.textContent = TERR_LABEL_COMPANY;
        if (chkTerr) chkTerr.disabled = false;

        fetchCompanyBundleForRadarCpv().then(function (b) {
            var territories = (b && b.territories) ? b.territories : [];
            var hasTerritories = territories && territories.length > 0;
            if (!hasTerritories) {
                if (chkCompany) {
                    chkCompany.checked = false;
                    chkCompany.disabled = true;
                }
                setCompanyHint('Company profile: non ci sono territori configurati (aggiungili nel Company Profile).', true);
                persistRadarCpvMode('explore');
                applyCompanyModeUiCpv('explore');
                return;
            }

            if (chkCompany) chkCompany.disabled = false;
            var cpvPrefs = companyCpvPrefixesFromBundle(b && b.cpv);
            if (cpvInput) {
                cpvInput.disabled = true;
                cpvInput.value = cpvPrefs.length ? cpvPrefs.join(', ') : '';
            }
            if (cpvHidden) cpvHidden.value = '';
            if (clearBtn) clearBtn.disabled = true;
            setCompanyHint('', false);
            _vgRadarCpvLastMode = 'company';
        });
    }

    function initCompanyModeToggleCpv() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var chkCompany = form.querySelector('#radar-cpv-company-mode');
        if (!chkCompany) return;

        chkCompany.disabled = true;

        fetchCompanyBundleForRadarCpv().then(function (b) {
            var territories = (b && b.territories) ? b.territories : [];
            var hasTerritories = territories && territories.length > 0;
            if (!hasTerritories) {
                chkCompany.disabled = true;
                chkCompany.checked = false;
                persistRadarCpvMode('explore');
                applyCompanyModeUiCpv('explore');
                var hintCompany = document.getElementById('radar-cpv-company-hint');
                if (hintCompany) {
                    hintCompany.hidden = false;
                    hintCompany.textContent = 'Company profile: non ci sono territori configurati (aggiungili nel Company Profile).';
                }
                return;
            }

            chkCompany.disabled = false;
            var mode0 = loadRadarCpvMode();
            chkCompany.checked = mode0 === 'company';
            applyCompanyModeUiCpv(chkCompany.checked ? 'company' : 'explore');
        });

        chkCompany.addEventListener('change', function () {
            var on = !!chkCompany.checked;
            var mode = on ? 'company' : 'explore';
            persistRadarCpvMode(mode);
            applyCompanyModeUiCpv(mode);
            refresh();
        });

        var terrCb = document.getElementById('radar-cpv-in-saved-area');
        if (terrCb) {
            terrCb.addEventListener('change', function () {
                var c = form.querySelector('#radar-cpv-company-mode');
                if (c && c.checked) refresh();
            });
        }
    }

    function run() {
        initSavedAreaFromMap().finally(function () {
            buildTable();
            initCpvAutocomplete();
            initCompanyModeToggleCpv();
            initDefaultYearDates();
            refresh();
        });
        var form = qs('[data-radar-filters]', root);
        if (form) {
            form.addEventListener('submit', function (e) {
                e.preventDefault();
                refresh();
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
})(window, document);

